
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Industries', path: '/industries' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-[#faeee2]/95 backdrop-blur-md shadow-xl py-4 border-b border-[#f2decb]' 
          : 'bg-black/40 backdrop-blur-sm py-6 border-b border-white/10'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src="/logo.png" 
            alt="Capilano Management Consultancies" 
            className={`h-16 md:h-20 w-auto object-contain transition-all duration-300 ${
              !scrolled ? 'brightness-0 invert' : ''
            }`}
            onError={(e) => {
              e.target.style.display = 'none';
              if (e.target.nextSibling) {
                e.target.nextSibling.style.display = 'block';
              }
            }}
          />
          <div className={`hidden flex-col ml-3 transition-colors duration-300 ${scrolled ? 'text-brand-darkBrown' : 'text-white'}`}>
            <span className="text-xl font-serif font-bold tracking-wider uppercase">Capilano</span>
            <span className="text-[10px] tracking-widest uppercase opacity-80">Management Consultancies L.L.C</span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-3 lg:gap-6">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`text-base font-medium transition-all duration-200 px-4 py-1.5 rounded-lg ${
                  isActive
                    ? scrolled
                      ? 'text-brand-orange border-brand-orange bg-brand-orange/10 font-bold'
                      : 'text-white  border-white/80 bg-white/10 font-bold shadow-sm'
                    : scrolled
                    ? 'text-brand-darkBrown hover:text-brand-orange'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center">
          <Link
            to="/contact"
            className="px-8 py-3.5 rounded-full bg-brand-orange text-white text-sm font-semibold tracking-wide hover:bg-brand-darkBrown transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105 border border-brand-orange/20"
          >
            Book a Call
          </Link>
        </div>

        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={`md:hidden focus:outline-none transition-colors duration-300 ${
            scrolled ? 'text-brand-darkBrown' : 'text-white'
          }`}
          aria-label="Toggle Menu"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-[#faeee2] border-b border-[#f2decb] px-6 py-6 flex flex-col gap-4 shadow-2xl">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              className={`text-base font-medium py-2 px-4 rounded-md ${
                location.pathname === link.path 
                  ? 'text-brand-orange font-bold border border-brand-orange bg-brand-orange/10' 
                  : 'text-brand-darkBrown'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileMenuOpen(false)}
            className="mt-2 text-center py-3.5 rounded-full bg-brand-orange text-white text-sm font-semibold tracking-wider uppercase shadow-md"
          >
            Book a Call
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
